module.exports = __webpack_public_path__ + "static/img/10013 (2).57f15a3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10013 (2).webp
// module id = 2v1u
// module chunks = 14